import script from "./checkOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkOrder.vue?vue&type=script&lang=ts&setup=true"

import "./checkOrder.vue?vue&type=style&index=0&id=bc0c59b2&lang=scss"

const __exports__ = script;

export default __exports__